export const verificationFindTiersWithNullKeys = (data: any) => {
  return Object.keys(data).filter((tier: any) => {
    if (tier === 'fourth_tier') {
      return data[tier].pdf_file_paths.includes(null)
    }
    return Object.values(data[tier]).includes(null);
  });
}